'use client'
import React, { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import Gallery from '@components/Gallery'
import Video from '@components/Video'
import VideoGallery from '@components/VideoGallery'
import { IoMdPhotos, IoMdVideocam } from 'react-icons/io'
import { Navigation } from 'swiper/modules';
import Link from "next/link";

// Import Swiper styles
import "swiper/css";
import 'swiper/css/navigation';

const PropertyGallery = ({ propertyId, gallery, videoUrl }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);

    const openPopup = (index) => {
        if (gallery && gallery.length > 0) {
            setActiveSlide(index)
            setPopupOpen(true);
            // setPopupOpen(false);
            setVideoPopupOpen(false);
        }
    };

    const openVideoPopup = () => {
        setVideoPopupOpen(true);
        setPopupOpen(false);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    const closeVideoPopup = () => {
        setVideoPopupOpen(false);
    };

    return (
        <>
            <div className='hidden sm:block w-full h-full '>
                <Swiper
                    className="mySwiper w-full h-full "
                    navigation={true}
                    modules={[Navigation]}
                >
                    {videoUrl && (

                        <SwiperSlide key={'video'} className="relative w-full">
                            <div className='relative flex justify-center items-center w-full overflow-hidden'>
                                <Video className='z-20' url={videoUrl} height={"450"} />
                            </div>
                            <div className="absolute z-40 flex flex-row bottom-2 right-2 ">
                                <div className="flex flex-row items-center bg-maincolortrans rounded-md text-light p-1 cursor-pointer z-40" onClick={openVideoPopup}>
                                    <span>1</span>
                                    <IoMdVideocam
                                        className="ml-1"
                                    />
                                </div>
                                <div className="flex flex-row items-center bg-maincolortrans rounded-md text-light p-1 ml-1 cursor-pointer" onClick={openPopup}>
                                    <span>{gallery.length}</span>
                                    <IoMdPhotos
                                        className="ml-1"
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    )}
                    {gallery && gallery.map((image, index) => (
                        <SwiperSlide key={index} className="relative h-full">
                            <div className='w-full h-[500px] relative overflow-hidden'>
                                <Image
                                    onClick={() => openPopup(index)}
                                    src={image}
                                    // src={`https://rstbase.com/images/properties/${propertyId}/${image}`}
                                    alt="image"
                                    width={1000}
                                    height={667}
                                    priority={index == 0 ? true : false}
                                    placeholder="blur"
                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAYAAACqNX6+AAAAXUlEQVR42u3RMQEAAAgDoJnc6FrB0wMqUMl0eKOECEGIEIQIQYgQhAgRIgQhQhAiBCFCECIEIQgRghAhCBGCECEIQYgQhAhBiBCECEEIQoQgRAhChCBECEIQIoSrBfgKSs//8LAxAAAAAElFTkSuQmCC"
                                    // className='object-cover'
                                    className='contain'
                                // fill='true'

                                />
                            </div>
                            <div className="absolute z-40 flex flex-row bottom-2 right-2 ">
                                {videoUrl && (

                                    <div className="flex flex-row items-center bg-maincolortrans rounded-md text-light p-1 cursor-pointer z-40" onClick={openVideoPopup}>
                                        <span>1</span>
                                        <IoMdVideocam
                                            className="ml-1"
                                        />
                                    </div>
                                )}
                                <div className="flex flex-row items-center bg-maincolortrans rounded-md text-light p-1 ml-1 cursor-pointer" onClick={openPopup}>
                                    <span>{index + 1}/{gallery.length}</span>
                                    <IoMdPhotos
                                        className="ml-1"
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className='block sm:hidden'>
                <Swiper
                    className="mySwiper"
                >
                    {gallery && gallery.map((image, index) => (
                        <SwiperSlide key={index} className="relative">
                            <div className='w-full max-h-[270px] relative overflow-hidden'>
                                <Image
                                    onClick={() => openPopup(index)}
                                    src={image}
                                    // src={`https://rstbase.com/images/properties/${propertyId}/${image}`}
                                    alt="image"
                                    width={1000}
                                    height={667}
                                    priority={index == 0 ? true : false}
                                    placeholder="blur"
                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAYAAACqNX6+AAAAXUlEQVR42u3RMQEAAAgDoJnc6FrB0wMqUMl0eKOECEGIEIQIQYgQhAgRIgQhQhAiBCFCECIEIQgRghAhCBGCECEIQYgQhAhBiBCECEEIQoQgRAhChCBECEIQIoSrBfgKSs//8LAxAAAAAElFTkSuQmCC"
                                />
                            </div>
                            {videoUrl && (
                                <Link href={'#video'} className="absolute z-10 top-2 left-2 flex flex-row items-center bg-third rounded-md text-light p-1">
                                    <span>Video</span>
                                    <IoMdVideocam
                                        className="ml-1"
                                    />
                                </Link>
                            )

                            }
                            <div className="absolute z-10 bottom-2 right-2 flex flex-row items-center bg-maincolortrans rounded-md text-light p-1">
                                <span>{index + 1}/{gallery.length}</span>
                                <IoMdPhotos
                                    className="ml-1"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <Gallery isOpen={isPopupOpen} onClose={closePopup} gallery={gallery} videoUrl={videoUrl} initialSlide={activeSlide} />
            <VideoGallery isVideoOpen={isVideoPopupOpen} onVideoClose={closeVideoPopup} videoUrl={videoUrl} />
        </>
    )
}

export default PropertyGallery